import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface StylesheetConfig {
    href: string;
    routePatterns: RegExp[];
    exclude?: boolean; // If true, exclude on these routes, if false, include only on these routes
}

const stylesheets: StylesheetConfig[] = [
    {
        href: '/css/gutcheck.css',
        routePatterns: [
            // /^\/c(\/.*)?$/, // Company routes: /c, /c/, /c/meetings, etc.
            // /^\/portfolio(\/.*)?$/, // Portfolio routes: /portfolio, /portfolio/, /portfolio/meetings, etc.
            // /^\/advisor(\/.*)?$/, // Advisor routes: /advisor, /advisor/, /advisor/meetings, etc.
        ],
        exclude: true // Exclude gutcheck.css on these routes
    },
    {
        href: '/css/projects.css',
        routePatterns: [
            // /^\/c(\/.*)?$/, // Company routes: /c, /c/, /c/meetings, etc.
            // /^\/portfolio(\/.*)?$/, // Portfolio routes: /portfolio, /portfolio/, /portfolio/meetings, etc.
            // /^\/advisor(\/.*)?$/, // Advisor routes: /advisor, /advisor/, /advisor/meetings, etc.
        ],
        exclude: true // Exclude projects.css on these routes
    },
    // Add more stylesheets as needed
];

export const useConditionalStylesheets = () => {
    const location = useLocation();

    useEffect(() => {
        stylesheets.forEach(({ href, routePatterns, exclude = false }) => {
            const shouldInclude = routePatterns.some(pattern =>
                pattern.test(location.pathname)
            );

            const shouldLoad = exclude ? !shouldInclude : shouldInclude;

            // Find existing link element
            let linkElement = document.querySelector(`link[href*="${href}"]`) as HTMLLinkElement;

            if (shouldLoad && !linkElement) {
                // Add stylesheet
                linkElement = document.createElement('link');
                linkElement.rel = 'stylesheet';
                linkElement.href = `${process.env.PUBLIC_URL}${href}`;
                document.head.appendChild(linkElement);
            } else if (!shouldLoad && linkElement) {
                // Remove stylesheet
                linkElement.remove();
            }
        });
    }, [location.pathname]);
}; 